var render = function () {
  var _vm$currentRound$left, _vm$currentRound$left2, _vm$currentRound$cent, _vm$currentRound$cent2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('activity-stage', [_c('template', {
    slot: "instructions"
  }, [_vm._t("instructions")], 2), _vm.currentRound ? _c('section', {
    staticClass: "quotebubble",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('aside', {
    staticClass: "activity-side-image"
  }, [_c('img', {
    attrs: {
      "alt": (_vm$currentRound$left = _vm.currentRound.leftImage) === null || _vm$currentRound$left === void 0 ? void 0 : _vm$currentRound$left.image.description,
      "src": (_vm$currentRound$left2 = _vm.currentRound.leftImage) === null || _vm$currentRound$left2 === void 0 ? void 0 : _vm$currentRound$left2.image.src
    }
  })]), _c('section', {
    staticClass: "activity-content-container"
  }, [_c('header', {
    staticClass: "activity-header-quote"
  }, [_c('text-display-list', [_c('li', {
    staticClass: "quote-bubble-container",
    class: {
      isMobileView: _vm.isMobile
    }
  }, [_c('div', {
    style: _vm.quoteBubbleImage
  }, [_c('blinking-cursor-text', {
    attrs: {
      "text": _vm.currentRound.quote,
      "text-step": 0
    }
  })], 1)])])], 1), _c('div', {
    staticClass: "activity-subheader"
  }, [_c('text-display-list', {
    staticClass: "subheader-words"
  }, [_c('li', [_c('h2', [_vm._v("English Word:")]), _c('blinking-cursor-text', {
    attrs: {
      "text": _vm.currentRound.word,
      "text-step": 1
    }
  })], 1), _c('li', [_c('h2', [_vm._v("Meaning:")]), _c('blinking-cursor-text', {
    attrs: {
      "text": _vm.currentRound.meaning,
      "text-step": 2
    }
  })], 1)])], 1), _c('div', {
    staticClass: "activity-paragraph"
  }, [_c('img', {
    style: {
      maxWidth: _vm.isMobile ? '75px' : '150px'
    },
    attrs: {
      "alt": (_vm$currentRound$cent = _vm.currentRound.centerImage) === null || _vm$currentRound$cent === void 0 ? void 0 : _vm$currentRound$cent.image.description,
      "src": (_vm$currentRound$cent2 = _vm.currentRound.centerImage) === null || _vm$currentRound$cent2 === void 0 ? void 0 : _vm$currentRound$cent2.image.src
    }
  }), _c('blinking-cursor-text', {
    attrs: {
      "text": _vm.currentRound.paragraph,
      "text-step": 3
    }
  })], 1)])]) : _vm._e()], 2), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }